import Icon from '../icon/icon';
import './data-not-found.scss';

export const DataNotFound = ({ data }: any) => {
    return (
        <div className='box-dataNotFound'>
            <div className='dataNotFound'>
                <h2 className='mb-4'>{data.title}</h2>

                <Icon name='empty-mailbox' width='100' height='100' color='#C6C6C6'/>

                {data.description && (
                    <h4 className='mt-2'>{data.description}</h4>
                )}
            </div>
        </div>
    );
}